export { default } from './currency-exposure-chart';
